import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';

@Injectable({
  providedIn: 'root'
})
export class IpService {
  private ipUrl = 'https://www.cloudflare.com/cdn-cgi/trace';

  constructor(private http: HttpClient) {
  }

  public getIPAddress() {
    return this.http.get(this.ipUrl, {responseType: 'text'});
  }
}
